export default __webpack_public_path__ + "static/media/Yellow0007.7afc9464.png";